import { Typography } from '@/components/app'
import React from 'react'

interface SectionTitleProps {
  badge?: string
  title: string
  subtitle?: string
  centered?: boolean
  icon?: React.ReactNode
}

export function SectionTitle({
  badge,
  title,
  subtitle,
  centered = true,
  icon,
}: SectionTitleProps) {
  return (
    <div className={`space-y-3 md:space-y-4 max-w-[840px] mx-auto  ${centered ? 'text-center' : ''}`}>
      {/* Badge */}
      {badge && (
        <div className={`inline-flex items-center gap-2 w-fit py-2.5 px-5 rounded-full bg-secondary md:min-h-[50px] ${centered ? 'mx-auto' : ''}`}>
          {icon && (
            <span>
              {icon}
            </span>
          )}
          <Typography variant="h6" className="font-semibold tracking-wider">
            {badge}
          </Typography>
        </div>
      )}

      {/* Title */}
      <Typography variant="h2" className='text-balance'>
        {title}
      </Typography>

      {/* Subtitle */}
      {subtitle && (
        <Typography variant="body1" color="muted">
          {subtitle}
        </Typography>
      )}
    </div>
  )
}
